import React from 'react';
import { matchPath, Outlet, useLocation } from 'react-router-dom';

import 'src/styles/index.scss';

import { SHARE_ROUTE } from 'src/constants/routes';
import Head from 'src/components/common/Head';
import Header from 'src/components/common/Header';

export const PageLayout = () => {
  const location = useLocation();
  const isResultsRoute = Boolean(matchPath(SHARE_ROUTE, location.pathname));

  React.useEffect(() => {
    const preloader: HTMLElement | null = document.querySelector('.main-preloader');
    if (preloader) {
      document.body.removeChild(preloader);
    }
  }, []);

  React.useEffect(() => {
    document.querySelector('html')?.classList.toggle('main', !isResultsRoute);
    document.querySelector('html')?.classList.toggle('results', isResultsRoute);
  }, [isResultsRoute]);

  return (
    <>
      <Head />
      <div id="mainBanner" />
      <Header />
      <Outlet />
    </>
  );
};
